<template>
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns="http://www.w3.org/2000/svg">
        <g id="iconPlusCircle" transform="translate(-4 -4)">
            <path
                d="M16 4C22.6274 4 28 9.37258 28 16C28 22.6274 22.6274 28 16 28C9.37258 28 4 22.6274 4 16C4 9.37258 9.37258 4 16 4ZM16 9C15.4872 9 15.0645 9.38604 15.0067 9.88338L15 10L15 15L10 15C9.44772 15 9 15.4477 9 16C9 16.5128 9.38604 16.9355 9.88338 16.9933L10 17L15 17L15 22C15 22.5523 15.4477 23 16 23C16.5128 23 16.9355 22.614 16.9933 22.1166L17 22L17 17L22 17C22.5523 17 23 16.5523 23 16C23 15.4872 22.614 15.0645 22.1166 15.0067L22 15L17 15L17 10C17 9.44772 16.5523 9 16 9Z"
                id="Shape" fill-rule="evenodd" stroke="none" />
        </g>
    </svg>
</template>